<template>
  <div>
    <PageHeader :schema="$schemas.variation" />
    <PageContent>
      <DynamicFormPage
        :schema="$schemas.variation"
        :service="$api.variations"
      />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateVariation',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
